import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { CookieService } from 'ngx-cookie-service';
import { environment } from '../../../environments/environment';
import { RootScopeDeclare } from '../../core/rootscope-declare';
import { RootScopeService } from '../../core/shared-service/root-scope.service';
import { SsoLoginService } from '../services/sso-login.service';
import { SsoSaveAttemptedPaswordService } from '../services/sso-save-attempted-pasword.service';
import { SsoSyncPasswordService } from '../services/sso-sync-password.service';
import { SsoUserAuthenticationService } from '../services/sso-user-authentication.service';
import { UpdateUserPreferredLanguageService } from '../services/update-user-preferred-language.service';
import { UserCredentialService } from '../services/user-credential.service';
import { AuthenticationService } from '../../core/services/authentication.service';
import { NotificationService } from '../../core/notification/notification.service';
import { IUserCredentials } from '../services/pre-login.model';
import { LoggedInUserDeails } from '../services/login.model';
import { HaloLoaderService } from 'src/app/core/halo-loader/halo-loader.service';
import { FacilityService } from 'src/app/core/services/facility.service';
import { AmplitudeAnalyticsService } from 'src/app/core/services/amplitude-analytics.service';

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.css'],
})
export class LoginComponent implements OnInit {
  @ViewChild('ssoForm', { static: false }) ssoFormElem: ElementRef;

  cloudBasePath: string;
  loginForm: FormGroup;
  oamForm: FormGroup;
  rootScopeData: RootScopeDeclare;
  showPassword = false;
  staySigned = true;
  submitted = false;
  public ssoFederatedResponse: LoggedInUserDeails;
  public userValidations: LoggedInUserDeails;
  entryMismatch = false;
  isSSoError = false;
  ssoCookie: string;
  isCaptchaVerified = false;
  isCaptchaVisible = false;
  tokenkey: string;
  errorCode?: number  ;
  oamError = false;
  public showCaptcha = true;
  ssoFormRedirectionPath: string;
  showModal = false;
  zendeskToken: string;

  constructor(
    private chechkUserisSSO: SsoLoginService,
    private userCredentials: UserCredentialService,
    private fb: FormBuilder,
    private router: Router,
    private activatedRoute: ActivatedRoute,
    private rootScopeService: RootScopeService,
    private updateLanguage: UpdateUserPreferredLanguageService,
    private cookieService: CookieService,
    private ssoSavePassword: SsoSaveAttemptedPaswordService,
    private syncSsoPassword: SsoSyncPasswordService,
    private authenticateSsoUsers: SsoUserAuthenticationService,
    private authenticationService: AuthenticationService,
    private _notificationService: NotificationService,
    private _amplitudeAnalytics: AmplitudeAnalyticsService,
    private _facilityService: FacilityService,
    private loader: HaloLoaderService
  ) {
    this.getRootScopeData();
    this.rootScopeData.pageName = 'Login';
  }

  ngOnInit() {
    this.cloudBasePath = environment.cloudBasePath;
    this.ssoFormRedirectionPath = environment.SSOformAuthRedirectionUrl;
    this.loginForm = this.fb.group({
      email: ['', Validators.required],
      password: ['', Validators.required],
    });

    this.oamForm = this.fb.group({
      username: ['', Validators.required],
      password: ['', Validators.required],
      successurl: ['', Validators.required],
    });
    this.initializeLoginChecks();
    this.loader.resetProcess();
    this.authenticationService.updateAutoLogOutFlag(false);
    if (this.authenticationService.sosErrorCheckOnURLparams()) {
    }
  }
  // loggedIn user redirect to dashboard ,SSO user verification and redirection
  initializeLoginChecks() {
    if (this.cookieService.check('ssolang') === true) {
      this.rootScopeData.selectedLang = this.cookieService.get('ssolang');
    }
    const url = window.location.href;
    this.showCaptcha = false;
    this.isCaptchaVisible = false;
    setTimeout(() => {
          this.showCaptcha = true;
        });

    // if (this.cookieService.get('ssoFederated') === 'true') {
    if (url.indexOf('p_error_codes_list') > -1 || url.indexOf('p_error_code') > -1) {
        this.rootScopeData.selectedLang = this.activatedRoute.snapshot.queryParams.lang;
        if (url.indexOf('OAM-5') > -1) {
          this.oamError = true;

          this.isCaptchaVerified = false;
          this.isCaptchaVisible = true;
        }
        this.cookieService.delete('ssoCookie');
        this.isSSoError = true;
        // this.router.navigate(['/dashboard']);
        // this.rootScopeData.isAuthenticated = true;
        // localStorage.setItem('isLoggedIn', 'true');
      } else {
        const cookieExists: boolean = this.cookieService.check('ssoCookie');
        if (cookieExists === true) {
          this.ssoCookie = this.cookieService.get('ssoCookie');
          this.syncSsoPassword.post(this.ssoCookie).subscribe(
            data => {
              this.getSSOUserDetails(this.ssoCookie);
            },
            error => {
              console.error('API failed.');
            }
          );
        }
      }
    // }
  }

  getSSOUserDetails(ssoCookie: string) {
    this.authenticateSsoUsers.post(ssoCookie).subscribe(
      data => {
        this.cookieService.set('vtTokenKey', ssoCookie, 0, '', '', true, 'None');
        this.cookieService.delete('ssoCookie');
        let staySigned = this.cookieService.get('staySignedIn');
        if (staySigned === 'true') {
          localStorage.setItem('vtTokenKey', ssoCookie);
        } else {
          sessionStorage.setItem('vtTokenKey', ssoCookie);
        }
        this.cookieService.delete('staySignedIn');
        this.userValidations = data;
        // verify user type of users
        this.verifyUserTypeandRedirectToHome(this.userValidations);
      },
      error => {
        console.error('API failed.');
      }
    );
  }

  get loginvalidator() {
    return this.loginForm.controls;
  }

  onReset() {
    if (this.loginForm.dirty) {
      this.openModal();
      return;
    }
    this.router.navigate(['/landing']);
  }
  openModal(): void {
    this.showModal = true;
  }

  onPositiveConfirmation(): void {
    this.closeModal();
    this.router.navigate(['/landing']);
  }

  closeModal(): void {
    this.showModal = false;
  }

  getRootScopeData(): void {
    this.rootScopeService.getRootScope().subscribe(rootScopeData => (this.rootScopeData = rootScopeData));
  }

  public doLogin() {
    this.submitted = true;
    this.isSSoError = false;
    this._amplitudeAnalytics.logEvent({elementName: 'Login', action: "Click"});
    // check if any validation errors are there.
    if (this.loginForm.dirty && this.loginForm.valid) {
      const userName = this.loginForm.value.email;
      this.chechkUserisSSO.post(userName).subscribe(
        data => {        
          this._amplitudeAnalytics.logEvent({
            elementName: 'Login', 
            action: "API Call",
            additionalProperty: {
              status: 'Success'
            }
          });
          this.ssoFederatedResponse = data;

          localStorage.setItem('ssoFederated', this.ssoFederatedResponse.isSSOFederated);
          this.cookieService.set('ssoFederated', this.ssoFederatedResponse.isSSOFederated, 0, '', '', true, 'None');

          const passwordRaw = this.loginForm.value.password;
          const passwordEncoded = btoa(unescape(encodeURIComponent(this.loginForm.value.password)));

          let userCredentials: IUserCredentials;

          if (this.isCaptchaVisible) {
            userCredentials = { userName, passwordEncoded, passwordRaw : "" , skipCaptcha: 'true' };
          } else {
            userCredentials = { userName, passwordEncoded, passwordRaw : ""};
          }
          // check if sso or non-sso user
          if (
            this.ssoFederatedResponse == null ||
            this.ssoFederatedResponse === undefined ||
            this.ssoFederatedResponse.tokenKey == null ||
            this.ssoFederatedResponse.tokenKey === undefined
          ) {
            this.validateUserCredentials(userCredentials);
          } else {
            // check for sso enabled user
            userCredentials.oamEmail = this.ssoFederatedResponse.emailAddress;
            this.checkIfSSOFederatedUser(userCredentials, this.loginForm.value.password, this.ssoFederatedResponse.tokenKey);
          }
        },
        error => {
          this._amplitudeAnalytics.logEvent({
            elementName: 'Login', 
            action: "API Call",
            additionalProperty: {
              status: 'Error'
            }
          });          
          console.error('Error');
        }
      );
    }
  }
  // chehck if user is sso-enabled user
  checkIfSSOFederatedUser(userCredentials: IUserCredentials, passwordRaw : string, tokenkey: string) {
    // setting the password string to "" before sending the request
    this.ssoSavePassword.post(userCredentials).subscribe(
      data => {        
        this._amplitudeAnalytics.logEvent({
          elementName: 'Save SSO', 
          action: "API Call",
          additionalProperty: {
            status: 'Success'
          }
        });
      },
      error => {     
        this._amplitudeAnalytics.logEvent({
          elementName: 'Save SSO', 
          action: "API Call",
          additionalProperty: {
            status: 'Error'
          }
        });
        console.error('API failed.');
      }
    );
    this.cookieService.set('ssoCookie', tokenkey, 0, '', '', true, 'None');
    this.cookieService.set('staySignedIn', this.staySigned + '', 0, '', '', true, 'None');

    this.cookieService.set('ssolang', this.rootScopeData.selectedLang, 0, '', '', true, 'None');
    this.ssoFormElem.nativeElement.username.value = userCredentials.oamEmail;
    this.ssoFormElem.nativeElement.password.value = passwordRaw;
    this.ssoFormElem.nativeElement.successurl.value =
      environment.currentHostPath + '/halo.html?p=ssofedlogin';
    this.ssoFormElem.nativeElement.submit();
    // oam form ends
  }

  validateUserCredentials(userCredentials: IUserCredentials) {
    this.loader.startProcess();
    this.userCredentials.post(userCredentials).subscribe(
      data => {
        this.loader.endProcess();
        this.entryMismatch = false;
        this.userValidations = data;
        this.errorCode = undefined;
        this.zendeskToken = data.zendeskToken;
        if (localStorage.getItem('zendeskReturnToUrl') != null && localStorage.getItem('zendesklogoutMessage') === null) {
          let zendeskParams = encodeURIComponent('?jwt='+ this.zendeskToken +'&return_to='+ localStorage.getItem('zendeskReturnToUrl'));
          localStorage.removeItem('zendeskReturnToUrl');
          window.location.href ='https://halofitness.zendesk.com/access/jwt'+ decodeURIComponent(zendeskParams);

         }
         else if(localStorage.getItem('zendesklogoutMessage') != null){
          localStorage.removeItem('zendesklogoutMessage');
          localStorage.removeItem('zendeskReturnToUrl');

         }

        // verify user type of users
        this.verifyUserTypeandRedirectToHome(this.userValidations);
      },
      error => {
        this.loader.endProcess();
        this.entryMismatch = true;
        this.showCaptcha = false;
        this.isCaptchaVisible = false;
        setTimeout(() => {
          this.showCaptcha = true;
        });
        console.error('API failed.User credentilas mismatch');
        this.errorCode = error.error.match(/\d+/g).map(Number)[0];
        if (this.errorCode === 106 || this.errorCode === 128 || this.errorCode === 129) {
          this.isCaptchaVerified = false;
          this.isCaptchaVisible = true;
        }
      }
    );
  }
  verifyUserTypeandRedirectToHome(userValidations: LoggedInUserDeails) {    
    if(userValidations.gcpToken) localStorage.setItem("gcpToken", userValidations.gcpToken);
    // removal of cookie req after the dev of further pages. Local storage is only req.
    if (userValidations.isSSOFederated !== 'true') {
      if (this.staySigned === true) {
        localStorage.setItem('vtTokenKey', userValidations.tokenKey);
      } else {
        sessionStorage.setItem('vtTokenKey', userValidations.tokenKey);
      }
      this.cookieService.set('vtTokenKey', userValidations.tokenKey, 0, '', '', true, 'None');
    }

    if (typeof userValidations.userType !== 'undefined') {
      localStorage.setItem('vtUserType', userValidations.userType);
      this.cookieService.set('vtUserType', userValidations.userType, 0, '', '', true, 'None');
    }

    if (typeof userValidations.managerType !== 'undefined') {
      localStorage.setItem('vtManagerType', userValidations.managerType);
      this.cookieService.set('vtManagerType', userValidations.managerType, 0, '', '', true, 'None');
    }
    this._notificationService.fetch();
    if (userValidations.preferredLanguage !== this.rootScopeData.selectedLang) {
      this.rootScopeData.enablePopup = true;
    } else {
      this.chechkManagerType(userValidations);
    }
  }

  onPressOfYes(userValidations: LoggedInUserDeails) {
    // modal POpup yes
    this.updateUserLanguage(userValidations);
  }
  onPressofCancel(userValidations: LoggedInUserDeails) {
    // modal popup close
    this.chechkManagerType(userValidations);
  }

  updateUserLanguage(userValidations: LoggedInUserDeails) {
    // update language pref
    if (userValidations.isSSOFederated === 'true') {
      this.tokenkey = this.cookieService.get('vtTokenKey');
    } else {
      this.tokenkey = userValidations.tokenKey;
    }
    this.loader.startProcess();
    this.updateLanguage.post(this.rootScopeData.selectedLang, this.tokenkey).subscribe(
      data => {
        this.chechkManagerType(userValidations);
        this.rootScopeData.enablePopup = false;
        this.loader.endProcess();
      },
      error => {
        console.error('Error');
        this.loader.endProcess();
      }
    );
  }

  chechkManagerType(userValidations: LoggedInUserDeails) {
    // chehck manger Fac Type- conencted or Nonconnected

    this.authenticationService.authenticateUser();

  }
  // Captcha Success
  onCaptchaStatusChange(status: string): void {
    if (status === 'success') {
      this.onCaptchaSuccess();
    } else {
      this.onCaptchaFail();
    }
  }

  onCaptchaSuccess(): void {
    this.isCaptchaVerified = true;
  }

  onCaptchaFail(): void {
    this.isCaptchaVerified = false;
  }
}
